import PassSectionsEnum from '@/common/enums/PassSectionsEnum'
import { PassSectionFieldAliases } from '@/common/enums/ApplicationSectionFieldAliases'
import applicationViewMixin from './applicationViewMixin'

export default {
  mixins: [applicationViewMixin],

  computed: {
    visibleVisitorsCategoryField() {
      return this.fieldVisible(PassSectionFieldAliases.VISITORS_CATEGORY, PassSectionsEnum.pass)
    },

    visibleTerminalIdField() {
      return this.fieldVisible(PassSectionFieldAliases.TERMINAL_ID, PassSectionsEnum.pass)
    },

    needAgentCheck() {
      return Number(this.application.need_agent_check) === 1
    },

    visibleAgentOrganizationField() {
      return this.needAgentCheck && this.fieldVisible(PassSectionFieldAliases.AGENT_ORGANIZATION, PassSectionsEnum.pass)
    }
  }
}
